import Vue from 'vue';
import geMenuToggle from './ge-menu-toggle';

Vue.component('ge-menu-toggle', geMenuToggle);

export default geMenuToggle;



// WEBPACK FOOTER //
// ./scripts/ge-menu-toggle/index.js